import { SEARCH_AGGREGATES } from '@/utils/constants'
import { Checkbox } from 'antd'
import styled from 'styled-components'
import { AggregatesValue } from '~types/search'
import Label from '../../Label'

const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;

  .label {
    flex: 1;
  }

  .ant-checkbox-wrapper {
    padding-right: 6px;
    transform: scale(0.5);
  }
`

import { useEffect, useState } from 'react'

const FilterOnSale = ({
  defaultValue,
  onChange,
  agregateLabel = '',
}: {
  defaultValue: AggregatesValue
  onChange: (filter: string, value: string[]) => void
  agregateLabel?: string
}) => {
  const [value, setValue] = useState<string[]>((defaultValue as string[]) ?? [])

  useEffect(() => {
    setValue((defaultValue as string[]) ?? [])
  }, [defaultValue])

  const handleChange = (value: string[]) => {
    setValue(value)
    onChange(SEARCH_AGGREGATES.availablePromotions, value)
  }

  return (
    <Checkbox.Group
      className="filter-aggregate filter-aggregate-available-promotions"
      value={value}
      onChange={handleChange}
    >
      <CheckboxWrapper className="checkbox-wrapper">
        <label htmlFor="available-checkbox" className="label">
          <Label aggregateName={agregateLabel} />
        </label>
        <Checkbox value="true" id="available-checkbox" />
      </CheckboxWrapper>
    </Checkbox.Group>
  )
}

export default FilterOnSale
